export default {
      id: "Icon--arrowRight-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--arrowRight",
      toString: function () {
        return this.url;
      }
    }